import { useState, useEffect } from "react"

import ErrorMessage from "components/forms/error-message"
import lodash from "lodash"
import deepdash from "deepdash"
import { lang } from "config"
import Label from "components/forms/label"
import Input from "components/forms/input"
import Description from "components/forms/description"
import nProgress from "nprogress"
import toast from "react-hot-toast"
import SelectSearchable from "components/forms/select-searchable"

export default function Form({ data, errors, onSubmit }) {
    const _ = deepdash(lodash)

    const id = data?.id

    const [name, setName] = useState(data?.name ?? null)
    const [slug, setSlug] = useState(data?.slug ?? null)
    const [description, setDescription] = useState(data?.description ?? null)

    useEffect(() => {
        if (data) {
            setName(data.name ?? null)
            setSlug(data.slug ?? null)
            setDescription(data.description ?? null)
        }
    }, [data])

    const handleSubmit = (e) => {
        e.preventDefault()

        if (!nProgress.isStarted()) {
            onSubmit({
                id,
                name,
                slug,
                description
            })
        } else {
            toast.error("Previous action is loading")
        }
    }
    return (
        <form onSubmit={handleSubmit} className="mt-8 space-y-8">
            <div className="mt-10 sm:mt-0">
                <div className="md:grid md:grid-cols-3 md:gap-6">
                    <div className="md:col-span-1">
                        <div className="px-4 sm:px-0">
                            <h3 className="text-lg font-medium leading-6 text-gray-900">{lang.main_form}</h3>
                            <p className="mt-1 text-sm text-gray-600">{lang.please_fill_the_provided_form_input}</p>
                        </div>
                    </div>
                    <div className="mt-5 md:col-span-2 md:mt-0">
                        <div className="border sm:rounded-xl">
                            <div className="px-4 py-5 sm:p-6">
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <Label htmlFor="name" value={lang.name} />
                                        <Input placeholder="Caliburn" onChange={(e) => setName(e.target.value)} value={name} id="name" error={errors.name} />
                                        <Description error={errors.name} />
                                    </div>
                                    <div>
                                        <Label htmlFor="slug" value={'Slug'} />
                                        <Input placeholder="caliburn-something" onChange={(e) => setSlug(e.target.value)} value={slug} id="slug" error={errors.slug} />
                                        <Description error={errors.slug} />
                                    </div>
                                    <div>
                                        <Label htmlFor="description" value={lang.description} />
                                        <Input placeholder="Caliburn" onChange={(e) => setDescription(e.target.value)} value={description} id="description" error={errors.description} />
                                        <Description error={errors.description} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-8 text-xs text-right">
                <button type="submit" className="items-center px-6 py-3 text-white transition bg-neutral-800 rounded-xl active:hover:scale-90">
                    <span>{`${_.isEmpty(data) ? lang.create : lang.update}`}</span>
                </button>
            </div>
        </form>
    )
}